import { NgModule } from '@angular/core';

import { LayoutModule } from '@angular/cdk/layout';

import { BrowserModule, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';

import { MatMomentDateModule } from '@angular/material-moment-adapter';

import { MsalInterceptor, MsalModule } from '@azure/msal-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TaskListComponent } from './changeover/task-list/task-list.component';
import { ChangeoverDetailsComponent } from './changeover/changeover-details/changeover-details.component';
import { environment } from 'src/environments/environment';
import { PublicClientApplication } from '@azure/msal-browser';
import { ChangeoverComponent } from './changeover/changeover.component';
import { LandingComponent } from './landing/landing.component';
import { ReviewComponent } from './review/review.component';
import { GanttComponent } from './review/gantt/gantt.component';
import { TimeBlockBottomSheetComponent } from './review/time-block-bottom-sheet/time-block-bottom-sheet.component';
import { OperatorNoteDialogComponent } from './review/operator-note-dialog/operator-note-dialog.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { AddComponent } from './schedule/add/add.component';
import { ResetDBComponent } from './reset-db/reset-db.component';
import { TaskListItemComponent } from './changeover/task-list/task-list-item/task-list-item.component';
import { FinaliseDialogComponent } from './review/finalise-dialog/finalise-dialog.component';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { TaskBottomSheetComponent } from './changeover/task-bottom-sheet/task-bottom-sheet.component';
import { LineSetupComponent } from './line-setup/line-setup.component';
import { LinePickerComponent } from './common/line-picker/line-picker.component';
import { TimeBlockEditorDialogComponent } from './review/time-block-editor-dialog/time-block-editor-dialog.component';
import { DatetimePickerComponent } from './common/datetime-picker/datetime-picker.component';
import { DownloadsComponent } from './downloads/downloads.component';


@NgModule({
  declarations: [
    AppComponent,
    TaskListComponent,
    ChangeoverDetailsComponent,
    ChangeoverComponent,
    LandingComponent,
    ReviewComponent,
    GanttComponent,
    TimeBlockBottomSheetComponent,
    OperatorNoteDialogComponent,
    ScheduleComponent,
    AddComponent,
    ResetDBComponent,
    TaskListItemComponent,
    FinaliseDialogComponent,
    SpinnerComponent,
    TaskBottomSheetComponent,
    LineSetupComponent,
    LinePickerComponent,
    TimeBlockEditorDialogComponent,
    DatetimePickerComponent,
    DownloadsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HammerModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    LayoutModule,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatStepperModule,
    MatDatepickerModule,
    MatTabsModule,
    MatCardModule,
    MatMomentDateModule,
    MsalModule.forRoot(
      new PublicClientApplication(environment.msalConfig),
      environment.msalGuardConfig,
      environment.msalInterceptorConfig
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
